/* eslint-disable react-hooks/exhaustive-deps */
import { SAPopover } from "@saux/design-system-react";
import { loader } from "graphql.macro";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { executeGraphqlSubscribe } from "../../graphql/api";
import {
  updateConversations,
  updateInitialState,
} from "../../store/action-creators/conversationActionCreator";
import { updateConversationsLoader } from "../../store/action-creators/loaderActionCreators";
import fetchConversations, {
  fetchMessagesById,
  formatSelectedConversation,
  updateArchiveConversation,
} from "../../store/actions/conversationActions";
import { RECEIVED, SEND } from "../../utils/constants";
import {
  handleSubscriptionError,
  setAlert,
  simpleGTMDataLayer,
  twoStringsAreEqual,
  updateConversationsOrder,
  updateConversationsOrderCC,
} from "../../utils/utilities";
import ChatContent from "../chatContent/ChatContent";
import ChatList from "../chatList/ChatList";

const receiveMessagesSubscription = loader(
  "../../graphql/subscriptions/receiveMessagesByAdjusterId.graphql"
);

const Wrapper = styled.div`
  display: flex;
  height: 100%;
`;

export default function ArchivedConversations(props: any) {
  const [referenceElement, setReferenceElement] = useState<Element | null>(
    null
  );
  const user = useSelector((state: any) => state.user);
  const chat = useSelector((state: any) => state.chat);
  const [newMessage, setNewMessage] = useState<any>({});
  const [initialLoad, setInitialLoad] = useState(true);
  const {
    allConversations,
    selectedConversation,
    messagesById: messages,
  }: any = chat;
  const dispatch = useDispatch();
  const history = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  let messageSubscription: any;
  let {
    unreadMsgCount
  } = useSelector(
    (state: any) => state.chat
  );

  useEffect(() => {
    props.setPath("/archived-conversations");
    subscribeToMessage();
    dispatch(updateConversationsLoader({ isLoading: true }));
    dispatch(
      fetchConversations(
        { adjusterId: user?.attributes?.email, isArchived: true },
        (res) => {
          let id = query.get('id');
          sessionStorage.removeItem("archiveConversation");
          const sessionResponse = sessionStorage.getItem(user.email);
          sessionStorage.removeItem(user.email);
          let response: any = JSON.parse(sessionResponse || "{}");
          let requestedConversation = (res || []).find(
            (con: any) => con.conversationId === id
          );
          if (id && requestedConversation) {
            let conversations = (res || []).filter(
              (con: any) => con.conversationId !== id
            );
            dispatch(
              updateConversations([requestedConversation, ...conversations])
            );
            dispatch(formatSelectedConversation(requestedConversation));
          } else if (id && Object.keys(response).length !== 0) {
            updateConversationsOrderCC(response);
            dispatch(formatSelectedConversation(response));
          } else {
            dispatch(formatSelectedConversation(res[0]));
          }
          setInitialLoad(false);
          dispatch(updateConversationsLoader({ isLoading: false }));
        }
      )
    );
    return () => {
      dispatch(updateInitialState());
      messageSubscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    let filteredConversations = (allConversations || []).filter(
      (con: any) => con.conversationId !== newMessage.conversationId
    );
    dispatch(updateConversations([...filteredConversations]));
    if (filteredConversations.length > 0) {
      dispatch(formatSelectedConversation(filteredConversations[0]));
    } else {
      dispatch(formatSelectedConversation(null));
    }
    if (newMessage.message) {
      let type = twoStringsAreEqual(user?.email, newMessage?.from.id)
        ? SEND
        : RECEIVED;
      let newMsgDetails = {
        type: type,
        conversationId: newMessage?.conversationId,
        fromId: newMessage?.from.id
      };
      console.log(user);
      let sound = user?.profileInfo?.adjusterSetting?.notificationSoundValue;
      // if (isActiveParticipant(messageResponse.conversationId, userId[0])) {
      if (type === RECEIVED) {
        setAlert(newMsgDetails);
      }
    }
  }, [newMessage]);

  useEffect(() => {
    let conversationId = selectedConversation?.conversationId;
    if (conversationId) {
      history(`/archived-conversations?id=${conversationId}`);
      if (!(messages && messages[conversationId])) {
        dispatch(fetchMessagesById(conversationId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedConversation]);

  const subscribeToMessage = () => {
    messageSubscription = executeGraphqlSubscribe(
      receiveMessagesSubscription
    ).subscribe({
      next: ({ provider, value }: any) => {
        let messageResponse = value?.data?.onCreateMessageByAdjusterId;
        if ((messageResponse?.adjusterIds || []).includes(user.email)) {
          setNewMessage(messageResponse);
        }
      },
      error: ({ error, provider }: any) => {
        handleSubscriptionError(error);
      },
    });
  };

  function handleClose(
    event: React.MouseEvent<HTMLElement> | MouseEvent,
    index: number | null
  ) {
    setReferenceElement(null);
    if (index === 0) {
      dispatch(
        updateArchiveConversation({
          conversationId: selectedConversation.conversationId,
          adjusterId: user.email,
          archive: false,
        })
      );
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `Unarchived-Conversation-Click`,
        event_action: "Button Click",
        event_category: window.location.pathname,
        event_label: `Making conversation Unarchive`,
        event_value: `${user.fullName} Unarchived conversation with claim number ${selectedConversation.claimNumber}.`,
        claim_number: selectedConversation.claimNumber,
      });
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `Unarchived-Conversation-Click-Snowplow`,
        event_action: "Button Click",
        event_category: window.location.pathname + "/Snowplow",
        event_label: `Making conversation Unarchive`,
        event_value: `${user.fullName} Unarchived conversation with claim number ${selectedConversation.claimNumber}.`,
        claim_number: selectedConversation.claimNumber,
      });
    }
  }

  return (
    <Wrapper>
      {
        <ChatList
          menuOptions={true}
          setReferenceElement={setReferenceElement}
          onlyArchived={true}
          initialLoad={initialLoad}
        />
      }
      <ChatContent />
      <SAPopover
        data={["Unarchive Conversation"]}
        onClose={(e: MouseEvent, index: number | null) => handleClose(e, index)}
        placement="right"
        referenceElement={referenceElement}
        variant="popover-menu"
      />
    </Wrapper>
  );
}
